import React from "react";
import { TyLink, TyNavMenuMap } from "../../../../../types";
import QuickLink from "../../../../basic/quickLink";
import FlexDivider from "../../../../basic/flex-divider";
import { buildAnalytics, DataAnalyticsLocations, DataAnalyticsTypes } from "../../../../basic/analytics";

export default function Flyout({
  subNavMap,
  selectedMenu,
  index
}: {
  // subNavMap: TyNavMenuMap;
  subNavMap: any;
  selectedMenu: string;
  index?: any
}): JSX.Element {
  const SubMenuItem = ({ col }: { col: any }) => {
    return (
        <div className="flex flex-col space-y-base mb-3">
          {col?.map((item: any, idx: any) => (
            <QuickLink
              href={item.href}
              key={`hd-dt-hmi-${idx}`}
              className="hover:text-orange-500 text-sm hover:underline"
              dataAnalytics={buildAnalytics(DataAnalyticsLocations.Menu, DataAnalyticsTypes.Link, [DataAnalyticsLocations.Page, DataAnalyticsLocations.Header])}
              aria-posinset={idx + 1}
              aria-setsize={col.length}
              aria-label={`${item.label}, ${idx + 1} of ${col.length}`}
            >
              {item.label}
            </QuickLink>
          ))}
        </div>
    );
  };
  return (
    <div
      data-testid="flyout"
      className={`absolute top-full left-0 right-0 bg-white z-50 shadow-[0px_4px_20px_0px_rgba(0,0,0,0.3)] rounded-md  ${selectedMenu ? "block" : "hidden"
        }`} 
      style={{ left: `${index * 4}em`, width: '500px' }}
    >
      <div className="flex justify-center items-center w-full p-lg">
        <div className="flex space-x-2xl">
          <div className='grid grid-flow-col'>
            <span className='text-md font-bold'>{selectedMenu}</span>
            <FlexDivider alignment="vertical" className="hidden md:block w-[2px] ml-md" color="bg-sky-300"/>
          </div>
          <div>
            <SubMenuItem col={subNavMap} />
          </div>
        </div>
      </div>
      <div
        className={`content-none absolute top-[-5px] bg-white  w-[1rem] h-[1rem]  rotate-45 shadow-[-20px_-4px_25px_-4px_rgba(0,0,0,0.6)]`}
        style={{ left: `${(index) * 4}em` }}
      >
      </div>
    </div>


  );
}
